<div class="loading-bar" *ngIf="percent !== 100">
  <span>{{ title }}</span>
  <mat-progress-bar color="primary" [value]="percent"> </mat-progress-bar>
</div>
